module.exports = __webpack_public_path__ + "static/img/89.670ca2e4.png";